// src/sections/Section15.jsx
import React, { useState, useEffect, useMemo } from "react";

const Section15 = ({ contenuti }) => {
  // 1) Normalizzo in array e ordino per “ordine”
  const contenutiArray = useMemo(() => {
    const arr = Array.isArray(contenuti) ? contenuti : Object.values(contenuti);
    return arr.sort((a, b) => Number(a.ordine) - Number(b.ordine));
  }, [contenuti]);

  // 2) isMobile
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="container">
      {contenutiArray.map((content, index) => {
        // alias dei campi corretti
        const {
          titolo_1: titolo1,
          titolo_2: titolo2,
          descrizione_it: descrizione,
        } = content;

        return (
          <div
            key={index}
            className="d-flex flex-column align-items-center justify-content-center py-5"
            style={{ gap: "16px" }}
          >
            {/* Titolo suddiviso in due span con classi responsive */}
            <div className="title-section text-center">
              <span
                className={`black-text ${
                  isMobile
                    ? "d-block d-lg-none title-section-mobile"
                    : "d-none d-lg-block title-section"
                }`}
              >
                {titolo1}
              </span>
              <span
                className={`green-text ${
                  isMobile
                    ? "d-block d-lg-none title-section-mobile"
                    : "d-none d-lg-block title-section"
                }`}
              >
                {titolo2}
              </span>
            </div>

            {/* Descrizione HTML */}
            {descrizione && (
              <p
                className="custom-text mt-2 text-start"
                dangerouslySetInnerHTML={{ __html: descrizione }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Section15;
